import React from 'react'
import { browserHistory } from 'react-router'
import VendorEdit from '../../../components/Payables/Vendor/VendorEdit.jsx';
import VendorList from '../../../components/Payables/Vendors/VendorList.jsx';

export default class VendorTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        var newVendor = true;
        if(this.props.vendorId.length > 0 && this.props.vendorId !== 'new'){
            newVendor = false;
        }

        return (
            <div>
                <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                <VendorEdit vendorId={this.props.vendorId} newVendor={newVendor} />
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Payables/Vendor/Vendor.jsx